export const APP_NAME = 'insuranceOffer';
export const APP_ROOT_ID = `${APP_NAME}-root`;
export const DEFAULT_LOCALE = 'fi';
export const INSURED_OBJECTS_MAX = 20;
export const STRING_MAX_LENGTH = 100;
export const LONG_STRING_MAX_LENGTH = 500;
